export const headCellsUserSIP = [
    {
        id: 'id',
        numeric: false,
        disablePadding: false,
        label: '#'
    },
    {
        id: 'account',
        numeric: false,
        disablePadding: false,
        label: 'table.accountSIP',
    },
    {
        id: 'password',
        numeric: false,
        disablePadding: false,
        label: 'table.password',
    },
    {
        id: 'user',
        numeric: false,
        disablePadding: false,
        label: 'table.user',
    },
    {
        id: 'active',
        numeric: false,
        disablePadding: false,
        label: 'table.active',
    },
    {
        id: 'actions',
        numeric: false,
        disablePadding: false,
        label: 'table.actions',
    },
];
export const headCellsDetailMeetingMonitor = [
    {
        id: 'id',
        numeric: false,
        disablePadding: false,
        label: '#'
    },
    {
        id: 'fullName',
        numeric: false,
        disablePadding: false,
        label: 'systemMonitor.table.fullName',
    },
    {
        id: 'userName',
        numeric: false,
        disablePadding: false,
        label: 'systemMonitor.table.userName',
    },
    {
        id: 'time',
        numeric: false,
        disablePadding: false,
        label: 'systemMonitor.table.time',
    },
    {
        id: 'role',
        numeric: false,
        disablePadding: false,
        label: 'systemMonitor.text.role',
    },
    {
        id: 'speed',
        numeric: false,
        disablePadding: false,
        label: 'systemMonitor.table.speed',
    },
    {
        id: 'lag',
        numeric: false,
        disablePadding: false,
        label: 'systemMonitor.table.lag',
    },
    {
        id: 'fps',
        numeric: false,
        disablePadding: false,
        label: 'systemMonitor.table.fps',
    },
    {
        id: 'losspackage',
        numeric: false,
        disablePadding: false,
        label: 'systemMonitor.table.losspackage',
    },
    {
        id: 'actions',
        numeric: false,
        disablePadding: false,
        label: 'systemMonitor.table.actions',
    },
];


export const headCellsMeetingMonitor = [
    {
        id: 'id',
        numeric: false,
        disablePadding: false,
        label: '#'
    },
    {
        id: 'roomId',
        numeric: false,
        disablePadding: false,
        label: 'systemMonitor.table.roomId',
    },
    {
        id: 'roomName',
        numeric: false,
        disablePadding: false,
        label: 'systemMonitor.table.roomName',
    },
    {
        id: 'userHostId',
        numeric: false,
        disablePadding: false,
        label: 'systemMonitor.table.moderator',
    },
    {
        id: 'timeStarted',
        numeric: false,
        disablePadding: false,
        label: 'systemMonitor.table.startRoomTime',
    },
    {
        id: 'totalParticipantJoin',
        numeric: false,
        disablePadding: false,
        label: 'systemMonitor.table.totalParticipant',
    },
    {
        id: 'actions',
        numeric: false,
        disablePadding: false,
        label: 'systemMonitor.table.action',
    },
];

export const headCellsRecordings = [
    {
        id: 'id',
        numeric: false,
        disablePadding: false,
        label: '#'
    },
    {
        id: 'record_name',
        numeric: false,
        disablePadding: false,
        label: 'table.recordName',
    },
    {
        id: 'room_name',
        numeric: false,
        disablePadding: false,
        label: 'table.meetingTopic',
    },
    {
        id: 'room_id',
        numeric: false,
        disablePadding: false,
        label: 'table.meetingId',
    },
    {
        id: 'started_date',
        numeric: false,
        disablePadding: false,
        label: 'table.startTime',
    },
    {
        id: 'record_size',
        numeric: false,
        disablePadding: false,
        label: 'table.sizeFile',
    },
    {
        id: 'actions',
        numeric: false,
        disablePadding: false,
        label: 'table.actions',
    },
];

export const headCellsSystems = [
    {
        id: 'id',
        numeric: false,
        disablePadding: false,
        label: '#'
    },
    {
        id: 'systemCode',
        numeric: false,
        disablePadding: false,
        label: 'table.systemCode',
    },
    {
        id: 'systemValue',
        numeric: false,
        disablePadding: false,
        label: 'table.systemValue',
    },
    {
        id: 'systemDesc',
        numeric: false,
        disablePadding: false,
        label: 'table.systemDesc',
    },
    {
        id: 'systemAction',
        numeric: false,
        disablePadding: false,
        label: 'table.systemAction',
    }
];

export const headCellsRole = [
    {
        id: 'id',
        numeric: false,
        disablePadding: false,
        label: '#'
    },
    {
        id: 'name',
        numeric: false,
        disablePadding: false,
        label: 'manageRole:table.nameRole',
    },
    {
        id: 'desc',
        numeric: false,
        disablePadding: false,
        label: 'manageRole:table.desc'
    },
    {
        id: 'priority',
        numeric: false,
        disablePadding: false,
        label: 'manageRole:table.priority'
    },
    {
        id: 'status',
        numeric: false,
        disablePadding: false,
        label: 'manageRole:table.status'
    },
    {
        id: 'action',
        numeric: false,
        disablePadding: false,
        label: 'manageRole:table.action'
    },
]

export const headCellsRoleFunctions = [
    {
        id: 'id',
        numeric: false,
        disablePadding: false,
        label: '#'
    },
    {
        id: 'code',
        numeric: false,
        disablePadding: false,
        label: 'table.roleCode',
    },
    {
        id: 'name',
        numeric: false,
        disablePadding: false,
        label: 'table.roleName'
    },
    {
        id: 'description',
        numeric: false,
        disablePadding: false,
        label: 'table.roleDesc'
    },
    {
        id: 'status',
        numeric: false,
        disablePadding: false,
        label: 'manageRole:table.value'
    },
    {
        id: 'action',
        numeric: false,
        disablePadding: false,
        label: 'table.actions'
    },
]

export const headCellsStatistics = [
    {
        id: 'id',
        numeric: false,
        disablePadding: false,
        label: '#'
    },
    {
        id: 'name',
        numeric: false,
        disablePadding: false,
        label: 'meeting.table.name',
    },
    {
        id: 'email',
        numeric: false,
        disablePadding: false,
        label: 'meeting.table.email',
    },
    {
        id: 'time-start',
        numeric: false,
        disablePadding: false,
        label: 'meeting.table.time-start',
    },
    {
        id: 'time-end',
        numeric: false,
        disablePadding: false,
        label: 'meeting.table.time-end',
    },
    {
        id: 'time-in',
        numeric: false,
        disablePadding: false,
        label: 'meeting.table.time-in',
    },
    {
        id: 'status',
        numeric: false,
        disablePadding: false,
        label: 'meeting.table.status',
    }
];
